import React from 'react';

import FinishPaidRegistration from './FinishPaidRegistration';
import Register from './Register';

const InternationalCustomersRegistration = (props: any) => {
  const params = new URLSearchParams(props?.location?.search || '');
  const isCodeRegistration = params.get('mode') === 'code';

  if (isCodeRegistration) {
    return <Register {...props} internationalCustomers />;
  }

  return <FinishPaidRegistration {...props} internationalCustomers />;
};

export default InternationalCustomersRegistration;
